/**
 * @format
 * @flow
 */
import React from 'react';

// import * as RT from '../../constants/Routing'
// import { Link } from 'react-router-dom'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '../../components/Common/Modal';
import Loading from '../../components/Common/Loading';
import * as Actions from '../../actions/Auth';
import Logo1x from '../../assets/images/logo-square.png';
import Logo2x from '../../assets/images/logo-square@2x.png';

import FooterLinks from '../../components/Auth/FooterLink';

import * as RT from '../../constants/Routing';
import * as CONST from '../../constants/Const';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: 0,
      password: '',
      confirmpassword: '',
      authValid: false,
      passwordValid: false,
      confirmpasswordValid: false,
      formValid: false,
      formErrors: { auth: '', password: '', confirmpassword: '' }
    };
    const query = new URLSearchParams(this.props.location.search);
    this.email = query.get('email');
  }

  componentDidMount = () => {
    this.props.resetError();
    this.props.User.isLoggedIn = !!localStorage.getItem('logged_in');
    this.props.User.isSignedUp = !!localStorage.getItem('signed_up');
    const currentUser = localStorage.getItem('current_user');
    if (
      this.props.User.isLoggedIn &&
      this.props.User.isSignedUp &&
      currentUser
    ) {
      this.props.history.push(RT.TOP_PATH);
    }
  };

  _setValue = e => {
    const { name } = e.target;
    const { value } = e.target;
    this.setState({ [name]: value }, () => {
      this._validateField(name, value);
    });
  };

  _validateField = (fieldName, value) => {
    const fieldValidationErrors = this.state.formErrors;
    let { authValid } = this.state;
    let { passwordValid } = this.state;
    let { confirmpasswordValid } = this.state;
    switch (fieldName) {
      case 'auth':
        authValid = value.match(CONST.AUTHCODE_TEMPLATE);
        fieldValidationErrors.auth = authValid ? '' : CONST.INVALID_AUTHCODE;
        break;
      case 'password':
        passwordValid = value.match(CONST.PASSWORD_TMEPLATE);
        fieldValidationErrors.password = passwordValid
          ? ''
          : CONST.INVALID_PASSWORD;

        const { confirmpassword } = this.state;
        confirmpasswordValid = value === confirmpassword;
        fieldValidationErrors.confirmpassword = confirmpasswordValid
          ? ''
          : CONST.PASSWORD_NOT_MATCH;
        break;
      case 'confirmpassword':
        const { password } = this.state;
        confirmpasswordValid = value === password;
        fieldValidationErrors.confirmpassword = confirmpasswordValid
          ? ''
          : CONST.PASSWORD_NOT_MATCH;
        break;
      default:
        break;
    }

    this.setState(
      {
        formErrors: fieldValidationErrors,
        authValid,
        passwordValid,
        confirmpasswordValid
      },
      this.validateForm
    );
  };

  validateForm() {
    this.setState({
      formValid:
        this.state.confirmpasswordValid &&
        this.state.passwordValid &&
        this.state.authValid
    });
  }

  _errorClass = error => {
    return error.length === 0 ? '' : 'has-error';
  };

  _confirmPassword = e => {
    e.preventDefault();
    this.props.confirmPassword(
      this.email,
      this.state.auth,
      this.state.password
    );
  };

  _moveToTop = () => {
    localStorage.setItem('signed_up', true);
    this.props.modalCloseInAuth();
    this.props.history.push(RT.SIGN_IN_PATH);
  };

  _CloseError = () => {
    this.props.modalErrorClose();
  };

  render = () => {
    return (
      <div className="container">
        <Loading isOpen={this.props.App.loading} />
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle="パスワードの設定が完了しました"
          okClickHandler={this._moveToTop}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <Modal
          isOpen={this.props.App.errorShow}
          headerTitle="Error"
          okClickHandler={this._CloseError}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.errMsg}
        </Modal>
        <div className="bg-block">
          <div className="auth-box">
            <form>
              <div className="auth-img-block">
                <img
                  src={Logo1x}
                  srcSet={`${Logo1x} 1x,${Logo2x} 2x`}
                  alt=""
                  className=""
                />
              </div>
              <div className="form-group position-relative">
                <label htmlFor="auth">認証コード</label>
                <input
                  type="number"
                  onChange={this._setValue}
                  name="auth"
                  className={`form-control ${this._errorClass(
                    this.state.formErrors.auth
                  )}`}
                  id="auth"
                  placeholder="Confirmation code"
                />
                <small className="text-muted">
                  認証コードを入力してください
                  </small>
                <label className="error_text">
                  {this.state.formErrors.auth}
                </label>
              </div>
              <div className="form-group position-relative">
                <label htmlFor="password">新しいパスワード</label>
                <input
                  type="password"
                  onChange={this._setValue}
                  name="password"
                  className={`form-control ${this._errorClass(
                    this.state.formErrors.password
                  )}`}
                  id="password"
                  placeholder="Password"
                />
                <small className="text-muted">
                  新しいパスワードを入力してください
                  </small>
                <label className="error_text">
                  {this.state.formErrors.password}
                </label>
              </div>
              <div className="form-group position-relative">
                <label htmlFor="confirmpassword">
                  新しいパスワード（確認）
                  </label>
                <input
                  type="password"
                  onChange={this._setValue}
                  name="confirmpassword"
                  className={`form-control ${this._errorClass(
                    this.state.formErrors.confirmpassword
                  )}`}
                  id="confirmpassword"
                  placeholder="Password"
                />
                <small className="text-muted">
                  確認のため、もう一度パスワードを入力してください
                  </small>
                <label className="error_text">
                  {this.state.formErrors.confirmpassword}
                </label>
              </div>
              <div className="auth-button-block">
                <button
                  type="submit"
                  onClick={this._confirmPassword}
                  className="btn btn-primary"
                  disabled={!this.state.formValid}
                >
                  パスワード再設定メールを送信
                  </button>
              </div>
            </form>
            <FooterLinks />
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

export default withRouter(Container);
